import useSetRemoteFormState from '@hooks/useSetRemoteFormState';

const defaultValues = {
  emails: [''],
  mobiles: [''],
};

/**
 * When the user goes back by submitting a share quote or by clicking the back button,
 * we need to clear the remote share form state to prevent the previous values
 * from being populated.
 */
const useResetSaveForLaterRemoteForm = () => {
  return useSetRemoteFormState(defaultValues);
};

export default useResetSaveForLaterRemoteForm;
